import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const ClientContact = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        value={opsPlan?.clientContact}
        multiline
        onChange={(e) => {
          setOpsPlan((prev) => ({
            ...prev,
            clientContact: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        label="Event Organiser Contact"
        InputLabelProps={{
          shrink: opsPlan?.clientContact ? true : false,
        }}
        fullWidth
        autoComplete="off"
        name="opsPlan-clientContact"
      />
    </Grid>
  )
}

export default React.memo(ClientContact)
